module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "top-contributors"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": _vm.$t('message.discussionTopContributorsTitle'),
      "subTitle": _vm.$t('message.discussionTopContributorsSubTitle')
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('mu-flexbox', [_vm._l((5), function(item, index) {
    return (_vm.isLoading) ? _c('mu-flexbox-item', {
      key: 'contributor-loading-' + index
    }, [_c('mu-avatar', {
      attrs: {
        "backgroundColor": "#E9E9E8",
        "size": 40
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return (!_vm.isLoading) ? _c('mu-flexbox-item', {
      key: 'contributor-' + index
    }, [_c('mu-avatar', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.bottom",
        value: (item.display_name),
        expression: "item.display_name",
        modifiers: {
          "bottom": true
        }
      }],
      attrs: {
        "src": item.image,
        "color": "white",
        "backgroundColor": "#E9E9E8"
      },
      on: {
        "click": function($event) {
          return _vm.goTo(item.profile_url)
        }
      }
    })], 1) : _vm._e()
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fb16c77","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Questions/TopContributors/TopContributors.vue
// module id = 3048
// module chunks = 1